"use strict";

var _toConsumableArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/toConsumableArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiFilterButton = exports.FilterButton = void 0;

var react_1 = __importDefault(require("react"));

var icons_1 = require("../icons");

var AntIconWrapper_1 = require("./ant/AntIconWrapper");

var Button_1 = require("./ant/Button");

var Dropdown_1 = require("./ant/Dropdown");

function FilterButton(props) {
  var value = props.value,
      _onChange = props.onChange,
      options = props.options;
  return react_1.default.createElement(MultiFilterButton, Object.assign({}, props, {
    options: options,
    value: value !== undefined && value !== null ? [value] : undefined,
    onChange: function onChange(opt) {
      _onChange(opt ? opt[opt.length - 1] : undefined);
    }
  }));
}

exports.FilterButton = FilterButton;
var ALL_VALUE = 'all-value';

function MultiFilterButton(_ref) {
  var label = _ref.label,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      buttonProps = _ref.buttonProps,
      options = _ref.options,
      value = _ref.value,
      _ref$hideViewAllOptio = _ref.hideViewAllOption,
      hideViewAllOption = _ref$hideViewAllOptio === void 0 ? false : _ref$hideViewAllOptio;
  var viewAllOption = {
    label: 'View All',
    value: ALL_VALUE,
    icon: react_1.default.createElement(AntIconWrapper_1.AntIconWrapper, {
      children: react_1.default.createElement(icons_1.DeleteCircledOutline, null)
    })
  };
  var hasValue = value !== null && value !== undefined && (value === null || value === void 0 ? void 0 : value.length);
  var optionsWithViewAll = hideViewAllOption || !hasValue ? options : [viewAllOption, 'divider'].concat(_toConsumableArray(options));
  var selectedOptions = hasValue ? value.map(function (val) {
    return (0, Dropdown_1.getSelectableMenuOptions)(options).find(function (opt) {
      return opt.value === val;
    });
  }).filter(Boolean) : [];
  var selectedLabel = (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) > 1 ? "".concat(selectedOptions.length, " selected") : selectedOptions[0] ? selectedOptions[0].label : null;
  var buttonInner = (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("strong", null, label, ": "), react_1.default.createElement("span", null, "\xA0", (selectedLabel === null || selectedLabel === void 0 ? void 0 : selectedLabel.length) && selectedLabel.length > 30 ? "".concat(selectedLabel === null || selectedLabel === void 0 ? void 0 : selectedLabel.slice(0, 30), "...") : selectedLabel)) : "Filter ".concat(label);
  return react_1.default.createElement(Dropdown_1.Dropdown, {
    disabled: disabled,
    selectedOptions: selectedOptions,
    options: optionsWithViewAll,
    onOptionSelected: function onOptionSelected(selectedOption) {
      var selectedValue = selectedOption.value;

      if (selectedValue === ALL_VALUE) {
        onChange(undefined);
      } else {
        var selectedOptValue = selectedValue;
        var isSelected = value === null || value === void 0 ? void 0 : value.includes(selectedOptValue);
        var without = value ? value.filter(function (v) {
          return v !== selectedOptValue;
        }) : [];
        onChange(isSelected ? without : [].concat(_toConsumableArray(without), [selectedOptValue]));
      }
    },
    children: react_1.default.createElement(Button_1.Button, Object.assign({
      type: (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) ? 'primary' : 'default',
      style: {
        display: 'flex',
        alignItems: 'center'
      }
    }, buttonProps), buttonInner, "\xA0", react_1.default.createElement(icons_1.NavArrowDown, null))
  });
}

exports.MultiFilterButton = MultiFilterButton;